// material-ui

import emailconfirmationicon from '../../../assets/images/email-confirmation.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const EmailConfirmationIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={emailconfirmationicon} alt="E-mail outsource confirmation" width="22"  />
    );
};

export default EmailConfirmationIcon;
